import Admin from "../layout/admin";
import { Navigate } from "react-router-dom";
import store from 'store';
import general from "../utils/general";
import StylesheetLoader from "../components/stylesheet-loader";

const RouterHelper = ({ component, role, empty, withoutAccess }) => {
    const token = store.get('token');
    
    // Admin layout için gerekli CSS'ler
    const adminStylesheets = [
        "/assets/plugins/bootstrap/css/bootstrap.min.css",
        "/assets/css/main.css",
        "/assets/css/color_skins.css",
    ];

    // Auth sayfaları için gerekli CSS'ler
    const authStylesheets = [
        "/assets/plugins/bootstrap/css/bootstrap.min.css",
        "/assets/css/main.css",
        "/assets/css/authentication.css",
        "/assets/css/color_skins.css",
    ];
    
    // Eğer withoutAccess true ise, herhangi bir kontrol yapmadan component'i döndür
    if (withoutAccess) {
        return (
            <StylesheetLoader stylesheets={authStylesheets}>
                {component}
            </StylesheetLoader>
        );
    }
    
    // Token yoksa login sayfasına yönlendir
    if (!token || general.isNullOrEmpty(token)) {
        return <Navigate to="/auth/login" replace />;
    }
    
    // Token varsa Admin layout ile component'i render et
    return (
        <StylesheetLoader stylesheets={adminStylesheets}>
            <Admin>{component}</Admin>
        </StylesheetLoader>
    );
}

export default RouterHelper;